import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { Form, Button, Radio, Divider } from 'semantic-ui-react';

import { Commons } from 'components';
import cm from 'helpers/commons';
import storage from 'helpers/storage';
import toastr from 'helpers/toastr';

const propTypes = {};

const defaultProps = {};

class AddAuth extends Component {
  constructor(props) {
    super(props);
    this.state = {
      staffModal: {
        open: false,
        size: 'large'
      },
      staff: null,
      scope: 'COMPANY'
    };
  }

  componentWillMount() {
    const { fn } = this.props;
    fn.staffSel(1, null);
  }

  componentDidMount() {
    cm.mainTitle('권한 및 범위 설정');
  }

  //사용자 조회 팝업 노출
  searchClick = (type, dimmer) => {
    if (dimmer) {
      this.staffSel(1, null);
    }

    this.setState({
      dimmer,
      staffModal: {
        open: dimmer,
        close: this.searchClick
      }
    });
  };

  //사용자 조회
  staffSel = (page, keyword) => {
    const { fn } = this.props;

    fn.staffSel(page, keyword);
  };

  //사용자 팝업 이벤트
  choiceStaff = (data) => {
    this.setState({
      staffModal: { open: false },
      staff: data.staff
    });
  };

  delChoiceEvent = (id) => {};

  //범위 선택
  scopeChange = (e, { value }) => {
    cm.propsInit(this.props);
    this.setState({ scope: value });
  };

  success = () => {
    const { staff, scope } = this.state;
    const { fn, division, preset } = this.props;
    const companyInfo = ((storage.get('company') || {}).user || {}).company;

    if (!staff) {
      toastr('top-right', 'warning', '사용자을 선택하세요.');
      return;
    }

    const params = {
      id: staff.id,
      type: scope,
      orgCode: null,
      presetIdx: null
    };

    if (scope === 'DIVISION') {
      params['orgCode'] = division && division.value ? division.value : null;
    } else if (scope === 'COMPANY') {
      params['orgCode'] = (companyInfo || {}).id;
    }

    //orgcode가 없을 시
    if (!params['orgCode']) {
      if (scope === 'DIVISION') {
        toastr('top-right', 'warning', '부서를 선택하세요.');
        return;
      }
    }

    //권한을 선택 안했을 때
    if (!preset || !preset.value) {
      toastr('top-right', 'warning', '권한을 선택하세요.');
      return;
    } else {
      params['presetIdx'] = preset.value;
    }

    fn.authStaffAdd(params);
  };

  render() {
    const { staffModal, scope, staff } = this.state;
    const { presetList } = this.props;
    const style = {
      label: {
        width: '100px'
      },
      inputStyle: {
        display: 'block',
        width: '224px'
      }
    };

    return (
      <div>
        <Form>
          <Form.Group inline>
            <Form.Field>
              <label style={style.label}>사용자 선택</label>
              <Button
                className="label-btn"
                content="사용자"
                icon="plus"
                labelPosition="left"
                onClick={() => this.searchClick('staff', true)}
              />
            </Form.Field>
          </Form.Group>
          <Form.Group inline>
            <Form.Field>
              <label style={style.label}></label>
              {staff ? (
                <div style={{ display: 'inline-table' }}>
                  <p>{`아이디 :  ${staff.signid ? staff.signid : ''}`}</p>
                  <p>{'이름 : ' + staff.name}</p>
                  <p>{'부서 : ' + cm.divisionNavi(staff.orgCode)}</p>
                  <p>{'사원번호 : ' + staff.comidnum}</p>
                </div>
              ) : null}
            </Form.Field>
          </Form.Group>
          <Form.Group inline>
            <label style={style.label}>범위 선택</label>
            <Form.Field
              control={Radio}
              label="회사 전체"
              value="COMPANY"
              checked={scope === 'COMPANY'}
              onChange={this.scopeChange}
            />
            <Form.Field
              style={{ marginLeft: '18px' }}
              control={Radio}
              label="부서 단위"
              value="DIVISION"
              checked={scope === 'DIVISION'}
              onChange={this.scopeChange}
            />
          </Form.Group>
          <Form.Group inline>
            <label style={style.label}></label>
            <span>* 회사에 소속된 모든 사용자을 관리할 수 있습니다.</span>
          </Form.Group>
          {scope === 'DIVISION' ? (
            <Form.Group inline>
              <label style={style.label}></label>
              <Commons.Division isLabel={false} inputStyle={style.inputStyle} />
            </Form.Group>
          ) : null}
          <Form.Group inline>
            <label style={style.label}>권한 선택</label>
            <Commons.PresetList inputStyle={style.inputStyle} presetType={scope} defaultValue={0} />
          </Form.Group>
          <Divider />
          <Button.Group floated="right">
            <Button
              inverted
              color="black"
              style={{ width: 120 }}
              onClick={(e) => {
                this.context.router.history.go('/main/accountManagement');
              }}
            >
              취소
            </Button>
            <Button color="green" style={{ width: 200, marginLeft: 8 }} onClick={this.success}>
              완료
            </Button>
          </Button.Group>
        </Form>

        <Commons.StaffSearchModal modal={staffModal} staffSel={this.staffSel} choiceEvent={this.choiceStaff} />
      </div>
    );
  }
}

AddAuth.propTypes = propTypes;
AddAuth.defaultProps = defaultProps;

AddAuth.contextTypes = {
  router: PropTypes.object.isRequired
};

AddAuth = connect(
  (state) => ({
    division: state.commons.depth,
    preset: state.commons.preset
  }),
  (dispatch) => ({})
)(AddAuth);

export default AddAuth;
